import React, { Fragment } from "react";
import "./product_table.css";
const ProductTable = () => {
  return (
    <Fragment>
      <div className="product_table_body">
        <div className="product_width_col">
          <div className="table_value">51 سانت </div>
          <div className="table_key">طول</div>
        </div>
        <div>
          <hr className="table_line" />
        </div>
        <div className="product_width_col">
          <div className="table_value">51 سانت </div>
          <div className="table_key">عرض</div>
        </div>
        <div>
          {" "}
          <hr className="table_line" />
        </div>
        <div className="product_width_col">
          <div className="table_value">قرمز</div>
          <div className="table_key">رنگ</div>
        </div>
        <div>
          {" "}
          <hr className="table_line" />
        </div>
        <div className="product_width_col">
          <div className="table_value">نخ</div>
          <div className="table_key">جنس</div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductTable;
// test commmit2
